import * as React from 'react';
import { connect } from 'react-redux';
import {
  SINGLE_CHOICE,
  MULTIPLE_CHOICE,
  SINGLE_CHOICE_IMAGE,
  STATEMENT_CHOICE,
  OPEN_QUESTION,
  RANKING_TEXT,
  SCENARIO,
  FILL_IN_THE_BLANK,
  DRAG_AND_DROP_TEXT,
  TEXT_MATCHING,
  HOTSPOT
} from 'constants/questionTypes';
import { isRandomizedOptionsLoaded } from 'store/course/selectors';
import { isRandomizeAnswersEnabled } from 'store/settings/selectors';
import { RootAppState } from 'store/types';
import MultipleChoice from './MultipleChoice';
import SingleChoiceImage from './SingleChoiceImage';
import { QuestionContainer, QuestionContainerOverlay } from './Question.styled';
import StatementChoice from './Statement';
import OpenQuestion from './OpenQuestion';
import RankingText from './RankingText';
import Scenario from './Scenario';
import FillInTheBlank from './FillInTheBlank';
import DragAndDropText from './DragAndDropText';
import TextMatching from './TextMatching';
import Hotspot from './Hotspot';

type QuestionProps = {
  id: string;
  type: string;
  isAnswered: boolean;
  allowSubmit?: boolean;
  bodyBackground: { [key: string]: any };
  hasRandomizedOptionsLoaded?: boolean;
  randomizeAnswersEnabled?: boolean;
};

export class Question extends React.PureComponent<QuestionProps, {}> {
  render() {
    const {
      id,
      type,
      isAnswered,
      bodyBackground,
      allowSubmit = false,
      randomizeAnswersEnabled,
      hasRandomizedOptionsLoaded
    } = this.props;
    return (
      <QuestionContainer>
        {randomizeAnswersEnabled &&
          hasRandomizedOptionsLoaded &&
          renderQuestion(id, type, isAnswered, allowSubmit)}
        {!randomizeAnswersEnabled && renderQuestion(id, type, isAnswered, allowSubmit)}
        <QuestionContainerOverlay isShown={isAnswered} bodyBackground={bodyBackground} />
      </QuestionContainer>
    );
  }
}

function renderQuestion(id: string, type: string, isAnswered: boolean, allowSubmit: boolean) {
  switch (type) {
    case SINGLE_CHOICE:
      return (
        <MultipleChoice
          id={id}
          allowSubmit={allowSubmit}
          type={type}
          isSingleAnswer
          isAnswered={isAnswered}
        />
      );
    case SINGLE_CHOICE_IMAGE:
      return (
        <SingleChoiceImage id={id} allowSubmit={allowSubmit} type={type} isAnswered={isAnswered} />
      );
    case MULTIPLE_CHOICE:
      return (
        <MultipleChoice id={id} allowSubmit={allowSubmit} type={type} isAnswered={isAnswered} />
      );
    case STATEMENT_CHOICE:
      return (
        <StatementChoice id={id} allowSubmit={allowSubmit} type={type} isAnswered={isAnswered} />
      );
    case OPEN_QUESTION:
      return <OpenQuestion id={id} allowSubmit={allowSubmit} type={type} isAnswered={isAnswered} />;
    case RANKING_TEXT:
      return <RankingText id={id} allowSubmit={allowSubmit} type={type} isAnswered={isAnswered} />;
    case SCENARIO:
      return <Scenario id={id} allowSubmit={allowSubmit} type={type} isAnswered={isAnswered} />;
    case FILL_IN_THE_BLANK:
      return (
        <FillInTheBlank id={id} allowSubmit={allowSubmit} type={type} isAnswered={isAnswered} />
      );
    case DRAG_AND_DROP_TEXT:
      return (
        <DragAndDropText id={id} allowSubmit={allowSubmit} type={type} isAnswered={isAnswered} />
      );
    case TEXT_MATCHING:
      return <TextMatching id={id} allowSubmit={allowSubmit} type={type} isAnswered={isAnswered} />;
    case HOTSPOT:
      return <Hotspot id={id} allowSubmit={allowSubmit} type={type} />;
    default:
      return null;
  }
}

function mapStateToProps(state: RootAppState) {
  return {
    randomizeAnswersEnabled: isRandomizeAnswersEnabled(state),
    hasRandomizedOptionsLoaded: isRandomizedOptionsLoaded(state)
  };
}

export default connect(mapStateToProps)(Question);
